import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, Building, MessageCircle, Menu } from 'lucide-react';

const tabs = [
  { path: '/dashboard/admin', label: 'Home', icon: LayoutDashboard, exact: true },
  { path: '/dashboard/admin/orders', label: 'Orders', icon: Package },
  { path: '/dashboard/admin/pgs', label: 'PGs', icon: Building },
  { path: '/dashboard/admin/chats', label: 'Support', icon: MessageCircle },
  { path: '/dashboard', label: 'More', icon: Menu, isMore: true },
];

const AdminBottomNav = ({ onMoreClick }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 lg:hidden safe-bottom" data-testid="admin-bottom-nav">
      <div className="flex items-center justify-around h-16 px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = tab.exact ? pathname === tab.path : pathname.startsWith(tab.path) && !tab.isMore;
          return (
            <button
              key={tab.path + tab.label}
              onClick={() => tab.isMore ? onMoreClick?.() : navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active ? 'text-indigo-600' : 'text-slate-400'
              }`}
              data-testid={`admin-bnav-${tab.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default AdminBottomNav;
